import { render, staticRenderFns } from "./salesmanQrcode.vue?vue&type=template&id=4885ee72&scoped=true"
import script from "./salesmanQrcode.vue?vue&type=script&lang=js"
export * from "./salesmanQrcode.vue?vue&type=script&lang=js"
import style0 from "./salesmanQrcode.vue?vue&type=style&index=0&id=4885ee72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885ee72",
  null
  
)

export default component.exports